var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_471",
    "data-name": "Ellipse 471",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#18be58"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(3.773 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027",
    transform: "translate(0 7.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    "data-name": "Path 3244",
    d: "M18.254,231.287H16.16a3.124,3.124,0,0,0-.823.111,3.135,3.135,0,0,0-2.794-1.718h-3.7A3.135,3.135,0,0,0,6.05,231.4a3.124,3.124,0,0,0-.823-.111H3.133A3.136,3.136,0,0,0,0,234.42v.84a1.882,1.882,0,0,0,1.88,1.88H19.507a1.882,1.882,0,0,0,1.88-1.88v-.84A3.136,3.136,0,0,0,18.254,231.287ZM5.71,232.813v3.074H1.88a.627.627,0,0,1-.627-.627v-.84a1.882,1.882,0,0,1,1.88-1.88H5.226a1.873,1.873,0,0,1,.492.066C5.713,232.674,5.71,232.743,5.71,232.813Zm8.713,3.074H6.963v-3.074a1.882,1.882,0,0,1,1.88-1.88h3.7a1.882,1.882,0,0,1,1.88,1.88Zm5.71-.627a.627.627,0,0,1-.627.627H15.676v-3.074c0-.07,0-.139-.008-.207a1.875,1.875,0,0,1,.492-.066h2.093a1.882,1.882,0,0,1,1.88,1.88Z",
    transform: "translate(0 -229.68)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2029",
    "data-name": "Group 2029",
    transform: "translate(1.396 3.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2028",
    "data-name": "Group 2028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    "data-name": "Path 3245",
    d: "M36.2,126.5a2.784,2.784,0,1,0,2.784,2.784A2.787,2.787,0,0,0,36.2,126.5Zm0,4.315a1.531,1.531,0,1,1,1.531-1.531A1.532,1.532,0,0,1,36.2,130.819Z",
    transform: "translate(-33.414 -126.504)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031",
    transform: "translate(6.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    d: "M170.681,43.729a3.719,3.719,0,1,0,3.719,3.719A3.723,3.723,0,0,0,170.681,43.729Zm0,6.185a2.466,2.466,0,1,1,2.466-2.466A2.469,2.469,0,0,1,170.681,49.914Z",
    transform: "translate(-166.962 -43.729)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2033",
    "data-name": "Group 2033",
    transform: "translate(14.423 3.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2032",
    "data-name": "Group 2032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    "data-name": "Path 3247",
    d: "M348.078,126.5a2.784,2.784,0,1,0,2.784,2.784A2.787,2.787,0,0,0,348.078,126.5Zm0,4.315a1.531,1.531,0,1,1,1.531-1.531A1.532,1.532,0,0,1,348.078,130.819Z",
    transform: "translate(-345.294 -126.504)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.9080000944c7c20d8d034440fa8f9a52.svg";
export { ForwardRef as ReactComponent };